module.exports = __webpack_public_path__ + "img/avataruniverse.1cece250.webp";